import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

const NAV_LINKS = [
  { label: 'Quem Somos', to: '/sobre' },
  { label: 'Serviços', to: '/servicos' },
  { label: 'Nosso Método', to: '/metodo' },
  { label: 'Blog', to: '/blog' },
]

function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  return (
    <header className='fixed left-0 top-0 z-50 w-full border-b border-dorac-border/60 bg-white/80 backdrop-blur-md'>
      <div className='container mx-auto px-4'>
        <nav className='flex h-16 items-center justify-between md:h-20'>
          <Link to='/' className='group flex items-center gap-2'>
            <span className='font-display text-2xl font-black uppercase tracking-tight text-dorac-ink md:text-3xl'>
              Dorac
            </span>
          </Link>

          <ul className='hidden items-center gap-1 md:flex'>
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={`rounded-lg px-3 py-2 text-sm font-medium transition-all duration-150 ${
                    location.pathname === link.to
                      ? 'bg-dorac-purple text-white'
                      : 'text-dorac-ink/70 hover:bg-gray-100 hover:text-dorac-ink'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className='hidden items-center gap-3 md:flex'>
            <a
              href='https://api.whatsapp.com/send?phone=554396659096&text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais!'
              target='_blank'
              rel='noopener noreferrer'
              className='btn-dorac text-sm'
            >
              Fale Conosco
            </a>
          </div>

          <button
            className='flex h-10 w-10 flex-col items-end justify-center gap-1.5 rounded-lg transition-colors hover:bg-gray-100 md:hidden'
            aria-label='Menu'
            onClick={() => setIsOpen(!isOpen)}
          >
            <span
              className='block h-0.5 rounded-full bg-dorac-ink transition-all duration-300 ease-out'
              style={{
                width: isOpen ? '20px' : '20px',
                transform: isOpen ? 'translateY(6px) rotate(45deg)' : 'none',
              }}
            />
            <span
              className='block h-0.5 rounded-full bg-dorac-ink transition-all duration-200 ease-out'
              style={{
                width: '14px',
                opacity: isOpen ? 0 : 1,
                transform: isOpen ? 'translateX(6px)' : 'none',
              }}
            />
            <span
              className='block h-0.5 rounded-full bg-dorac-purple transition-all duration-300 ease-out'
              style={{
                width: isOpen ? '20px' : '20px',
                transform: isOpen ? 'translateY(-6px) rotate(-45deg)' : 'none',
              }}
            />
          </button>
        </nav>
      </div>

      {isOpen && (
        <div className='border-t border-dorac-border/60 bg-white md:hidden'>
          <ul className='flex flex-col gap-1 px-4 py-3'>
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  onClick={() => setIsOpen(false)}
                  className='block rounded-lg px-3 py-2 text-sm font-medium text-dorac-ink/70 hover:bg-gray-100 hover:text-dorac-ink'
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li className='pt-2'>
              <a
                href='https://api.whatsapp.com/send?phone=554396659096&text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais!'
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => setIsOpen(false)}
                className='btn-dorac w-full justify-center text-sm'
              >
                Fale com a Dorac
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  )
}

export default Header
